import { render, staticRenderFns } from "./ModalRubricas.vue?vue&type=template&id=4aa32bb2&"
import script from "./ModalRubricas.vue?vue&type=script&lang=js&"
export * from "./ModalRubricas.vue?vue&type=script&lang=js&"
import style0 from "./ModalRubricas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports